import Nav from '../components/common/Nav';
import Footer from '../components/common/Footer';
import Hero from '../components/home/Hero';
import About from '../components/home/About';
import LatestPosts from '../components/home/LatestPosts';
import Newsletter from '../components/home/Newsletter';
import SEO from '../components/common/SEO';

export default function Home() {
  return (
    <>
      <SEO 
        title="Kaspar Tiri"
        description="Co-founder of Ready Player Me, a cross-game avatar platform used by 150k+ developers. Raised $72M from a16z, Plural, and many others."
        url="/"
      />
      <Nav />
      <Hero />
      <About />
      <LatestPosts />
      <Newsletter />
      <Footer />
    </>
  );
}

